import { render, staticRenderFns } from "./BaseAction.vue?vue&type=template&id=152f66e9&scoped=true&"
import script from "./BaseAction.vue?vue&type=script&lang=js&"
export * from "./BaseAction.vue?vue&type=script&lang=js&"
import style0 from "./BaseAction.vue?vue&type=style&index=0&id=152f66e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152f66e9",
  null
  
)

export default component.exports